import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocationIcon from '../../assets/icons/location';
import SearchIcon from '../../assets/icons/search';
import WorkIcon from '../../assets/icons/work';
import { FORM_FIELDS, LOCATION_LIST, WORK_SCHEDULE } from '../../config/consts';
import Dropdown from '../Dropdown';
import classes from './style.module.scss';

export default function Search({ onSearch }) {
  const [form, setForm] = useState({});
  const { t } = useTranslation();

  const handleSearch = () => {
    const data = Object.values(FORM_FIELDS).reduce((tempData, field) => {
      if (form?.[field]) return { ...tempData, [field]: form?.[field] };
      return tempData;
    }, {});

    onSearch(data);
  };

  useEffect(() => {
    handleSearch();
  }, [form?.location, form?.workSchedule]);

  useEffect(() => {
    if (!form?.title) {
      handleSearch();
    }
  }, [form?.title]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleChangeDropdown = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.container}>
        <div className={classes.inputContainer}>
          <div className={classes.icon}>
            <SearchIcon />
          </div>
          <input
            type="text"
            name={FORM_FIELDS.TITLE}
            value={form?.[FORM_FIELDS.TITLE] || ''}
            placeholder={t('search_input_placeholder')}
            onChange={handleInputChange}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.icon}>
            <LocationIcon />
          </div>
          <Dropdown
            onChange={(value) => handleChangeDropdown(FORM_FIELDS.LOCATION, value)}
            placeHolder={t('search_location')}
            isAllOptionActive
            value={form?.[FORM_FIELDS.LOCATION]}
            list={LOCATION_LIST.map((location) => ({
              label: location,
              value: location
            }))}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.icon}>
            <WorkIcon />
          </div>
          <Dropdown
            onChange={(value) => handleChangeDropdown(FORM_FIELDS.WORK_SCHEDULE, value)}
            placeHolder={t('search_job_type')}
            isAllOptionActive
            value={form?.[FORM_FIELDS.WORK_SCHEDULE]}
            list={Object.entries(WORK_SCHEDULE(t)).map(([value, label]) => ({ value, label }))}
          />
        </div>
        <div className={classes.buttonContainer}>
          <button type="submit" className={classes.button}>
            {t('search_find_button')}
          </button>
        </div>
      </div>
    </form>
  );
}

Search.propTypes = {
  onSearch: PropTypes.func.isRequired
};
